import React from 'react';
import { connect } from 'react-redux'
import { Spin } from 'antd';
import {subsetByLang} from '../../virtuoso/helper';
import ClampLines from './ClampLines';
//import ClampLines from 'react-clamp-lines';
import i18n from "i18next";

/** Используется для удаления HTML разметки из описания. Иначе в списке будет текст с ссылками 
 * см. https://stackoverflow.com/questions/74669280/removing-html-tags-from-string-in-react */
const regex = /(<([^>]+)>)/gi;

/** Компонента, отображающая описание элемента. Значение для предиката http://purl.org/dc/terms/description
 * 
 * В начале Description отображает загрузку, в этот момент запрашивается информация об описании , если 
 * значение найдено, то отображается найденноей значения, если нет, то отображается "" */
const Loading = () => <span><Spin size="small" /></span>
const Label = ({lang, description}) => {

    const toString = (record) =>{
        if (record.description) return record.description.value;        
        if (record.definition) return record.definition.value;
        if (record.comment) return record.comment.value;
        if (record.dctd) return record.dctd.value;
        return "";
    };

    const subset = (description)?subsetByLang(description, lang, "description"): [];
    //console.log("Description.js const Label = ({lang, description})", lang, description, subset, JSON.stringify(description));
    const label = (Array.isArray(subset)&&subset.length>0)
        ? toString(subset[0]).replace(regex, "").replace("&nbsp;", " ")
        : "";    
    return (
        <ClampLines text={label} rows={1}/>
    )
}
        // <ClampLines text={label} id="default" lines={1} moreText={i18n.t('components.widgets.description_moreText')} 
        //     lessText={i18n.t('components.widgets.description_lessText')} innerElement="span" stopPropagation={true} />

class Description extends React.Component {
    state = {
        loaded: false,
        value: undefined
    };

    componentDidMount() {
        if ((this.props.description==null) || (this.props.description==undefined) || (this.props.IRI))
            this.loadDescription();
    };

    componentDidUpdate(prevProps) {
        //console.log(this, JSON.stringify(settings.catalog));
        if ((this.props.description==null) || (this.props.description==undefined) || (this.props.IRI!=prevProps.IRI)) 
            this.loadDescription(this.props.IRI!=prevProps.IRI);
    };

    static getDerivedStateFromProps(props, state) {
        if (props.description)
            return {
                loaded: true,
                value: props.description
            };
        return null; // Return null to indicate no change to state.
    }

    loadDescription (reload = false) {
        if (this.state.loaded && !reload) return;
        const {onLoadDescription, actions, IRI, graph} = this.props;
        if (onLoadDescription)
            onLoadDescription(actions, IRI, graph)
                .then ((response) =>{
                    this.setState({loaded: true});
                })
                .catch(e => { 
                    console.error("Error!", e);
                    this.setState({loaded: true});
                });
    }

    render(){
        const Component = (this.state.loaded)? Label: Loading;
        const { lang } = this.props;
        const description = this.props.description || this.state.value;
        //console.log(this, description);
        return(
            <Component lang={lang} description={description} />
        )
    }
}

function mapStateToProps(state, props) {
    //Значения в store redux
    const {vadms, vset} = state;
    //Параметры, которые могут прийти из настроек
    const {graph, IRI, lang, description} = props;
    return {
        graph: (graph)? graph: vset.graph,
        lang: (lang)?lang: vset.lang,
        IRI,
        vset,
        description,
    };
}

export default connect(
    mapStateToProps,
    dispatch => ({
        onLoadDescription (actions, IRI, graph){
            return dispatch(actions.loadDescription(IRI, graph))
        },
    })
)(Description);